import config from 'config';

export default {
    onboarding: config.SURVEY_URL,
    termsOfUse: 'https://legal.yoga-go.io/page/terms-of-use',
    privacyPolicy: 'https://legal.yoga-go.io/page/privacy-policy',
    refundPolicy: 'https://legal.yoga-go.io/page/refund-policy',
};
